<template>
  <div>
        <div class="breadcrumb">
            <Breadcrumb>
                <Breadcrumb-item href="#">数据中心</Breadcrumb-item>
                <Breadcrumb-item>销售名单利用统计</Breadcrumb-item>
            </Breadcrumb>
        </div>
        <div>
            <Form label-position="left" :label-width="80">
                <Row :gutter="32">
                    <Col span="5">
                        <FormItem label="获得名单日期:" :label-width="100">
                            <Date-picker type="daterange" :value="defaultData" @on-change="getTimeDateChange" placement="bottom-start" style="width: 100%"></Date-picker>

                            <!-- <DatePicker type="month" :value="defaultData" @on-change="startMonth" :options="start" placeholder="选择开始月" style="width: 200px"></DatePicker> -->
                            <!-- <DatePicker type="month" :value="defaultData" @on-change="endMonth" :options="end" placeholder="选择结束月" style="width: 200px"></DatePicker> -->
                        </FormItem>
                    </Col>
                    <Col span="5">
                        <FormItem label="截止日期:">
                            <Date-picker type="date" @on-change="stopTimeDateChange" :value="expiration" placeholder="选择日期" style="width: 100%"></Date-picker>
                            <!-- <DatePicker @on-change="stopTimeDateChange"
                                        type="month" placement="bottom-start"
                                        :options="option"
                                        :value="defaultData"
                                        placeholder="选择截止时间" style="width: 200px">
                            </DatePicker> -->
                        </FormItem>
                    </Col>
                    <Col span="5">
                        <FormItem label="选择销售:">
                            <admin-user-select :status="1" adminGroupCode="adviser" v-model="queryParam.adviserId"></admin-user-select>
                        </FormItem>
                    </Col>
                    <Col span="6">
                        <FormItem label="查看方式:">
                            <Radio-group v-model="queryParam.personage">
                                <Radio label="0">按个人查看</Radio>
                                <Radio label="1">按分组查看</Radio>
                            </Radio-group>
                        </FormItem>
                    </Col>
                    <Col :span="2">
                      <Button type="primary" :loading="searchLoading" :disable="searchLoading" icon="search"
                        @click="search">搜索
                        </Button>
                    </Col>
                </Row>
            </Form>
        </div>
        <div class="btn-wrap">
          <Row>
            <Col>
              <Button type="primary" :loading="searchLoading" :disable="searchLoading"
                      @click="exportData">导出
              </Button>
              <Button type="primary" :loading="searchLoading" :disable="searchLoading"
                      @click="showSummaryData">查看汇总结果
              </Button>
            </Col>
          </Row>
        </div>
        <List ref="dataList" :tableColumns="table" listUrl="/data/report/queryadviserdata"
            :params="queryParam" :onLoading="onLoading" :reload="reload" pageSize="50"></List>
        
        <Modal v-model="tableRulePrompt" title="规则">
            {{tableRulePromptContent}}
            <div slot="footer">
                <Button type="text" size="large" @click="cancel">取消</Button>
                <Button type="primary" size="large" :loading="onLoading" @click="cancel">确定</Button>
            </div>
        </Modal>

        <Modal v-model="showSummaryDataModal" title="查看汇总结果">
            <div>【注册名单数】 {{summaryData.totalNum}}</div>
            <div>【邀约数】{{summaryData.totalInviteNum}}</div>
            <div>【出席数】{{summaryData.totalAttendNum}}</div>
            <div>【成交数】{{summaryData.totalTransactionsNum}}</div>
            <div>【邀约率】{{summaryData.inviteRatio}}%</div>
            <div>【出席率】{{summaryData.attendRatio}}%</div>
            <div>【成交率】{{summaryData.transactionsRatio}}%</div>
            <div slot="footer">
                <Button type="text" size="large" @click="cancel">取消</Button>
                <Button type="primary" size="large" @click="cancel">确认</Button>
            </div>
        </Modal>
  </div>
</template>

<script>
export default {
    data () {
        let $constant = this.$constant
        let $moment = this.$moment
        return {
            reload: 0,
            searchLoading: false,
            start: {
                disabledDate (date) {
                    return $moment(date, 'YYYY-MM-DD').format('X') <= $moment($moment().year($moment().year() - 1).startOf('day'), 'YYYY-MM-DD').format('X')
                }
            },
            end: {
                disabledDate (date) {
                    return $moment(date, 'YYYY-MM-DD').format('X') >= $moment($moment().year($moment().year()).startOf('day'), 'YYYY-MM-DD').format('X')
                }
            },
            option: {
                disabledDate (date) {
                    return $moment(date, 'YYYY-MM-DD').format('X') >= $moment($moment().year($moment().year()).startOf('day'), 'YYYY-MM-DD').format('X')
                }
            },
            onLoading: false,
            tableRulePrompt: false,
            showSummaryDataModal: false,
            summaryData: {},
            defaultData: [], // 默认起始时间显示
            expiration: '', // 默认截止时间显示
            tableRulePromptContent: '',
            queryParam: {
                createStartTime: '',
                createEndTime: '',
                startTime: '',
                endTime: '',
                personage: '0',
                adviserId: '',
                expirationDate: ''
            },
            table: [
                {
                    title: '销售姓名',
                    align: 'center',
                    key: 'nickName',
                    fixed: 'left',
                    width: 100
                },
                {
                    title: '销售分组',
                    align: 'center',
                    key: 'groupName',
                    fixed: 'left',
                    width: 100,
                    render: (h, params) => {
                        let row = params.row
                        let group = row.groupName ? $constant.getEnum($constant.adviserGroup, Number(row.groupName)).text : '未分组'
                        return h('div', group)
                    }
                },
                {
                    title: '市场名单量',
                    align: 'center',
                    key: 'bazaarNum',
                    width: 120,
                    renderHeader: (h,params)=>{
                        let tableHeader = '【时间条件】：学员首次分配时间在筛选时间内【渠道条件】：非二维码推荐【归属条件】：首次分配课程顾问为对应销售'
                        return h('div', {
                            style: { color: '#3399ff' },
                            on: { click: ()=>this.showPrompt(tableHeader) }
                        }, '市场名单量');
                    }
                },
                {
                    title: '市场名单外呼量',
                    align: 'center',
                    key: 'bazaarCallNum',
                    width: 120,
                    renderHeader: (h,params)=>{
                        let tableHeader = '【拨号条件】：被叫号码为市场名单量中学员的手机号且接通的量【名单流转条件】：呼叫时间在该名单二次分配/流入公库时间之前【归属条件】：呼叫人工号 = 首次分配课程顾问工号 '
                        return h('div',{
                            style: { color: '#3399ff' },
                            on: { click: ()=>this.showPrompt(tableHeader) }
                        }, '市场名单外呼量');
                    }
                },
                {
                    title: '市场名单邀约数',
                    align: 'center',
                    key: 'bazaarInviteNum',
                    width: 120,
                    renderHeader: (h,params)=>{
                        let tableHeader = '【课程条件】：至少有一节试听课且为外教课状态为：非管理员取消【学生条件】：市场名单内的学生【归属条件】：约课人ID=首次分配课程顾问ID '
                        return h('div',{
                            style: { color: '#3399ff' },
                            on: { click: ()=>this.showPrompt(tableHeader) }
                        }, '市场名单邀约数');
                    }
                },
                {
                    title: '市场名单邀约率',
                    align: 'center',
                    key: 'bazaarInviteRatio',
                    width: 120,
                    renderHeader: (h,params)=>{
                        let tableHeader = '市场名单邀约数/市场名单量'
                        return h('div',{
                            style: { color: '#3399ff' },
                            on: { click: ()=>this.showPrompt(tableHeader) }
                        }, '市场名单邀约率');
                    },
                    render: (h, params)=>{
                        let row = params.row
                        return h('div', row.bazaarInviteRatio + '%')
                    }
                },
                {
                    title: '市场名单出席数',
                    align: 'center',
                    key: 'bazaarAttendNum',
                    width: 120,
                    renderHeader: (h,params)=>{
                        let tableHeader = '【课程条件】：为市场名单至少有一节课程                 状态为：已上课  的课程数 '
                        return h('div',{
                            style: { color: '#3399ff' },
                            on: { click: ()=>this.showPrompt(tableHeader) }
                        }, '市场名单出席数');
                    }
                },
                {
                    title: '市场名单出席率',
                    align: 'center',
                    key: 'bazaarAttendRatio',
                    width: 120,
                    renderHeader: (h,params)=>{
                        let tableHeader = '市场名单出席数/市场名单量'
                        return h('div',{
                            style: { color: '#3399ff' },
                            on: { click: ()=>this.showPrompt(tableHeader) }
                        }, '市场名单出席率');
                    },
                    render: (h, params)=>{
                        let row = params.row
                        return h('div', row.bazaarAttendRatio + '%')
                    }
                },
                {
                    title: '市场名单成交数',
                    align: 'center',
                    key: 'bazaarTransactionsNum',
                    width: 120,
                    renderHeader: (h,params)=>{
                        let tableHeader = '【学生条件】：市场名单内的学生【订单条件】：全额付清 or 支付成功【签单人条件】：签单人ID = 首次分配课程顾问为对应销售 '
                        return h('div',{
                            style: { color: '#3399ff' },
                            on: { click: ()=>this.showPrompt(tableHeader) }
                        }, '市场名单成交数');
                    }
                },
                {
                    title: '市场名单成交率',
                    align: 'center',
                    key: 'bazaarTransactionsRatio',
                    width: 120,
                    renderHeader: (h,params)=>{
                        let tableHeader = '市场名单成交数/市场名单数'
                        return h('div',{
                            style: { color: '#3399ff' },
                            on: { click: ()=>this.showPrompt(tableHeader) }
                        }, '市场名单成交率');
                    },
                    render: (h, params)=>{
                        let row = params.row
                        return h('div', row.bazaarTransactionsRatio + '%')
                    }
                },
                {
                    title: '平均成交周期',
                    align: 'center',
                    key: 'bazaarAverageTransactionsTime',
                    width: 120,
                    renderHeader: (h,params)=>{
                        let tableHeader = '【学生条件】：市场名单内的学生【订单条件】：全额付清 or 支付成功 【计算公式】：∑((学生1付款时间 - 学生1首次分配时间)+…+(学生n付款时间-学生n首次分配时间))/(市场名单成交数)   （每个市场名单成交的学生的（付款时间-首次分配时间）的和的平均数）'
                        return h('div',{
                            style: { color: '#3399ff' },
                            on: { click: ()=>this.showPrompt(tableHeader) }
                        }, '平均成交周期');
                    }
                },
                {
                    title: '转介绍名单量',
                    align: 'center',
                    key: 'introductionNum',
                    width: 120,
                    renderHeader: (h,params)=>{
                        let tableHeader = '【时间条件】：学员首次分配时间在筛选时间内【渠道条件】：二维码推荐【归属条件】：首次分配课程顾问为对应销售'
                        return h('div',{
                            style: { color: '#3399ff' },
                            on: { click: ()=>this.showPrompt(tableHeader) }
                        }, '转介绍名单量');
                    }
                },
                {
                    title: '转介绍名单外呼量',
                    align: 'center',
                    key: 'introductionCallNum',
                    width: 120,
                    renderHeader: (h,params)=>{
                        let tableHeader = '【被叫号码条件】：被叫号码为市场名单量中学员的手机号且接通的量 【归属条件】：  呼叫人工号 = 首次分配课程顾问工号 '
                        return h('div',{
                            style: { color: '#3399ff' },
                            on: { click: ()=>this.showPrompt(tableHeader) }
                        }, '转介绍名单外呼量');
                    }
                },
                {
                    title: '转介绍名单邀约数',
                    align: 'center',
                    key: 'introductionInviteNum',
                    width: 120,
                    renderHeader: (h,params)=>{
                        let tableHeader = '【课程条件】：至少有一节试听课且为外教课                  状态为：非管理员取消             【学生条件】：转介绍名单量内的学生【归属条件】：约课人ID=首次分配课程顾问ID'
                        return h('div',{
                            style: { color: '#3399ff' },
                            on: { click: ()=>this.showPrompt(tableHeader) }
                        }, '转介绍名单邀约数');
                    }
                },
                {
                    title: '转介绍名单邀约率',
                    align: 'center',
                    key: 'introductionInviteRatio',
                    width: 120,
                    renderHeader: (h,params)=>{
                        let tableHeader = '转介绍名单要约束/转介绍名单量'
                        return h('div',{
                            style: { color: '#3399ff' },
                            on: { click: ()=>this.showPrompt(tableHeader) }
                        }, '转介绍名单邀约率');
                    },
                    render: (h, params)=>{
                        let row = params.row
                        return h('div', row.introductionInviteRatio + '%')
                    }
                },
                {
                    title: '转介绍名单出席数',
                    align: 'center',
                    key: 'introductionAttendNum',
                    width: 120,
                    renderHeader: (h,params)=>{
                        let tableHeader = '【课程条件】：为转介绍名单至少有一节课程                 状态为：已上课  的课程数 '
                        return h('div',{
                            style: { color: '#3399ff' },
                            on: { click: ()=>this.showPrompt(tableHeader) }
                        }, '转介绍名单出席数');
                    }
                },
                {
                    title: '转介绍名单出席率',
                    align: 'center',
                    key: 'introductionAttendRatio',
                    width: 120,
                    renderHeader: (h,params)=>{
                        let tableHeader = '转介绍名单出席数/转介绍名单数 '
                        return h('div',{
                            style: { color: '#3399ff' },
                            on: { click: ()=>this.showPrompt(tableHeader) }
                        }, '转介绍名单出席率');
                    },
                    render: (h, params)=>{
                        let row = params.row
                        return h('div', row.introductionAttendRatio + '%')
                    }
                },
                {
                    title: '转介绍名单成交数',
                    align: 'center',
                    key: 'introductionTransactionsNum',
                    width: 120,
                    renderHeader: (h,params)=>{
                        let tableHeader = '【学生条件】：转介绍名单内的学生【订单条件】：全额付清 or 支付成功【签单人条件】：签单人ID = 首次分配课程顾问为对应销售'
                        return h('div',{
                            style: { color: '#3399ff' },
                            on: { click: ()=>this.showPrompt(tableHeader) }
                        }, '转介绍名单成交数');
                    }
                },
                {
                    title: '转介绍名单成交率',
                    align: 'center',
                    key: 'introductionTransactionsRatio',
                    width: 120,
                    renderHeader: (h,params)=>{
                        let tableHeader = '市场名单成交数/市场名单数'
                        return h('div',{
                            style: { color: '#3399ff' },
                            on: { click: ()=>this.showPrompt(tableHeader) }
                        }, '转介绍名单成交率');
                    },
                    render: (h, params)=>{
                        let row = params.row
                        return h('div', row.introductionTransactionsRatio + '%')
                    }
                },
                {
                    title: '平均成交周期',
                    align: 'center',
                    key: 'introductionAverageTransactionsTime',
                    width: 120,
                    renderHeader: (h,params)=>{
                        let tableHeader = '【学生条件】：市场名单内的学生【订单条件】：全额付清 or 支付成功【计算公式】：     ∑((学生1付款时间 - 学生1首次分配时间)+…+(学生n付款时间-学生n首次分配时间))/(市场名单成交数)   （每个转介绍名单的学生的（付款时间-首次分配时间）的和的平均数）'
                        return h('div',{
                            style: { color: '#3399ff' },
                            on: { click: ()=>this.showPrompt(tableHeader) }
                        }, '平均成交周期');
                    }
                },
                {
                    title: '老旧名单量',
                    align: 'center',
                    key: 'oldNum',
                    width: 120,
                    renderHeader: (h,params)=>{
                        let tableHeader = '【时间条件】：二次分配时间 or 公库捞回的时间在时间筛选的范围内【渠道条件】：任意渠道【归属条件】：对应销售至少获得过名单一次即算一个名单量'
                        return h('div',{
                            style: { color: '#3399ff' },
                            on: { click: ()=>this.showPrompt(tableHeader) }
                        }, '老旧名单量');
                    }
                },
                {
                    title: '老旧名单外呼量',
                    align: 'center',
                    key: 'oldCallNum',
                    width: 120,
                    renderHeader: (h,params)=>{
                        let tableHeader = '【拨号条件】：被叫号码为老旧名单量中学员的手机号且接通的量【渠道条件】：任意渠道名单'
                        return h('div',{
                            style: { color: '#3399ff' },
                            on: { click: ()=>this.showPrompt(tableHeader) }
                        }, '老旧名单外呼量');
                    }
                },
                {
                    title: '老旧名单邀约量',
                    align: 'center',
                    key: 'oldInviteNum',
                    width: 120,
                    renderHeader: (h,params)=>{
                        let tableHeader = '【课程条件】：至少有一节试听课且为外教课 状态为：非管理员取消【学生条件】：老旧名单量中的学生【归属条件】：约课人ID为对应的销售'
                        return h('div',{
                            style: { color: '#3399ff' },
                            on: { click: ()=>this.showPrompt(tableHeader) }
                        }, '老旧名单邀约量');
                    }
                },
                {
                    title: '老旧名单邀约率',
                    align: 'center',
                    key: 'oldInviteRatio',
                    width: 120,
                    renderHeader: (h,params)=>{
                        let tableHeader = '老旧名单邀约量/老旧名单量'
                        return h('div',{
                            style: { color: '#3399ff' },
                            on: { click: ()=>this.showPrompt(tableHeader) }
                        }, '老旧名单邀约率');
                    },
                    render: (h, params)=>{
                        let row = params.row
                        return h('div', row.oldInviteRatio + '%')
                    }
                },
                {
                    title: '老旧名单出席量',
                    align: 'center',
                    key: 'oldAttendNum',
                    width: 120,
                    renderHeader: (h,params)=>{
                        let tableHeader = '【课程条件】： 为老旧名单邀约量对应的课程 状态为：已上课【渠道条件】：任意渠道【归属条件】：对应销售至少获得过名单一次即算一个名单量'
                        return h('div',{
                            style: { color: '#3399ff' },
                            on: { click: ()=>this.showPrompt(tableHeader) }
                        }, '老旧名单出席量');
                    }
                },
                {
                    title: '老旧名单出席率',
                    align: 'center',
                    key: 'oldAttendRatio',
                    width: 120,
                    renderHeader: (h,params)=>{
                        let tableHeader = '老旧名单出席量/老旧名单量'
                        return h('div',{
                            style: { color: '#3399ff' },
                            on: { click: ()=>this.showPrompt(tableHeader) }
                        }, '老旧名单出席率');
                    },
                    render: (h, params)=>{
                        let row = params.row
                        return h('div', row.oldAttendRatio + '%')
                    }
                },
                {
                    title: '老旧名单成交量',
                    align: 'center',
                    key: 'oldTransactionsNum',
                    width: 120,
                    renderHeader: (h,params)=>{
                        let tableHeader = '【学生条件】：老旧名单内的学生【渠道条件】：任意渠道【订单条件】：全额付清 或 支付成功'
                        return h('div',{
                            style: { color: '#3399ff' },
                            on: { click: ()=>this.showPrompt(tableHeader) }
                        }, '老旧名单成交量');
                    }
                },
                {
                    title: '老旧名单成交率',
                    align: 'center',
                    key: 'oldTransactionsRatio',
                    width: 120,
                    renderHeader: (h,params)=>{
                        let tableHeader = '老旧名单成交量/老旧名单量 '
                        return h('div',{
                            style: { color: '#3399ff' },
                            on: { click: ()=>this.showPrompt(tableHeader) }
                        }, '老旧名单成交率');
                    },
                    render: (h, params)=>{
                        let row = params.row
                        return h('div', row.oldTransactionsRatio + '%')
                    }
                },
                {
                    title: '市场业绩',
                    align: 'center',
                    key: 'marketPerformance',
                    width: 120,
                    renderHeader: (h,params)=>{
                        let tableHeader = '【订单条件】：        全额付清 or 支付成功【签单人条件】：签单人ID = 对应课程顾问ID【学生条件】： 市场名单成交数的学生 【学生条件】：'
                        return h('div',{
                            style: { color: '#3399ff' },
                            on: { click: ()=>this.showPrompt(tableHeader) }
                        }, '市场业绩');
                    }
                },
                {
                    title: '转介绍业绩',
                    align: 'center',
                    key: 'introductionPerformance',
                    width: 120,
                    renderHeader: (h,params)=>{
                        let tableHeader = '【订单条件】：        全额付清 or 支付成功【签单人条件】：签单人ID = 对应课程顾问ID【学生条件】： 转介绍名单成交数的学生 【学生条件】：'
                        return h('div',{
                            style: { color: '#3399ff' },
                            on: { click: ()=>this.showPrompt(tableHeader) }
                        }, '转介绍业绩');
                    }
                },
                {
                    title: '老旧资源业绩',
                    align: 'center',
                    key: 'oldPerformance',
                    width: 120,
                    renderHeader: (h,params)=>{
                        let tableHeader = '              【订单条件】：        全额付清 or 支付成功【签单人条件】：签单人ID = 对应课程顾问ID【学生条件】： 老旧资源名单成交数的学生 【学生条件】：'
                        return h('div',{
                            style: { color: '#3399ff' },
                            on: { click: ()=>this.showPrompt(tableHeader) }
                        }, '老旧资源业绩');
                    }
                },
                {
                    title: '总业绩',
                    align: 'center',
                    key: 'totalPerformance',
                    width: 120,
                    renderHeader: (h,params)=>{
                        let tableHeader = '市场业绩+转介绍业绩+老旧资源业绩'
                        return h('div',{
                            style: { color: '#3399ff' },
                            on: { click: ()=>this.showPrompt(tableHeader) }
                        }, '总业绩');
                    }
                }
            ]
        }
    },
    mounted: function () {
    },
    created() {
        let day = this.$moment(new Date()).subtract(1, 'days').format('YYYY-MM-DD');
        this.defaultData = [day, day]
        this.expiration = day
        this.queryParam.createStartTime = day
        this.queryParam.createEndTime = day
        this.queryParam.expirationDate = day


        // let month = this.$moment(new Date()).subtract(1,'months').format('YYYY-MM');
        // this.defaultData = month
        // this.queryParam.createStartTime = month
        // this.queryParam.createEndTime = month
        // this.queryParam.expirationDate = month
    },
    methods: {
        search () {
            this.reload = new Date().getTime()
        },
        onLoading (loading) {
            this.searchLoading = loading
        },
        showPrompt (value) {
            let self = this
            self.tableRulePrompt = true
            self.tableRulePromptContent = value
        },
        cancel () {
            let self = this
            self.tableRulePrompt = false
            self.showSummaryDataModal = false
        },
        getTimeDateChange (val) {
            let self = this
            console.log(`val`, val)
            self.queryParam.createStartTime = val[0]
            self.queryParam.createEndTime = val[1]
        },
        startMonth (val) {
            console.log(`val`, val)
            this.queryParam.createStartTime = val
        },
        endMonth (val) {
            console.log(`val`, val)
            this.queryParam.createEndTime = val
        },
        stopTimeDateChange (val) {
            let self = this
            self.queryParam.expirationDate = val
        },
        showSummaryData () {
            let self = this
            self.$http.post('/data/report/queryadviserdatatotalresult', self.queryParam).then(function (res) {
                if (res.data) {
                    self.summaryData = res.data
                    self.showSummaryDataModal = true
                }
            })
        },
        copy () {
            let self = this
            let clipboard = new Clipboard('.copyBtn')
            console.log(`clipboard`, clipboard)
            clipboard.on('success', e=>{
            self.$message.success('复制成功');
            clipboard.destroy();
            })
            clipboard.on('error', e=>{
                clipboard.destroy();
            })
        },
        exportData () {
            this.exportLoading = true
            this.$http.get('/data/report/exportadviserdata', {responseType: 'arraybuffer', params: this.queryParam}).then((response) => {
            if (response.data) {
                let blob = new Blob([response.data], {type: 'text/csv'})
                let link = document.createElement('a')
                link.target = '_blank'
                link.href = window.URL.createObjectURL(blob)
                link.download = '销售名单利用数据统计.csv'
                link.click()
                this.exportLoading = false
            } else {
                this.$Message.error(response.msg)
            }
            }).catch((e) => {
            this.exportLoading = false
            })
        }
    }
}
</script>

<style scoped>
  .btn-wrap {
    text-align: right;
    margin-top: 12px;
    margin-bottom: 12px;
  }
</style>


// WEBPACK FOOTER //
// SalesUtilizationList.vue?cf987d9c